import { Counter } from "@/app/nft/traits/views/counter"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { NftFiltersMoleculeReatom } from "../store.reatom"

export const TraitCounter = reatomComponent(() => {
  const { totalAppliedTraits } = useMolecule(NftFiltersMoleculeReatom)
  const count = totalAppliedTraits()

  return <Counter count={count} />
}, "TraitCounter")
